import React from "react";
import { makeStyles } from "@mui/styles";
import styles from "../../styles/homeFooterStyle.js";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import logo from "../../assets/img/haraka-logo-white.png";
import go from "../../assets/img/get-started-rocket.svg";
import appstore from "../../assets/img/Button.svg";
import playstore from "../../assets/img/Button (1).svg";
import { Email, Phone, RoomOutlined } from "@mui/icons-material";
import { handleAppStoreClick } from "../../common/appStoreUtils";

const useStyles = makeStyles(styles);

export default function HomeFooter() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);

  return (
    <footer style={{ backgroundColor: "#10190E" }}>
      <div className={classes.spacings}>
        <div className={classes.footerContainer}>
          <div className={classes.footerContainerOne}>
            <img
              onClick={() => navigate("/")}
              src={logo}
              alt="Logo"
              className={classes.footerLogo}
            />
            <p className={classes.p1FooterContainer}> {t(`getThereRelaxed`)}</p>

            <Link
              style={{ textDecoration: "none", color: "inherit" }}
              to="/login?signup=true"
            >
              <div className={classes.getStartedFooter}>
                <p className={classes.getThereRelaxedFooter}>
                  {t(`getStarted`)}
                </p>
                <img src={go} alt={t(`getStarted`)} />
              </div>
            </Link>

            <div className={classes.downloadavailabilityBtn}>
              <a
                href="https://apps.apple.com/ng/app/haraka-ride/id6753879505"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={appstore}
                  alt="Download on App Store"
                  style={{ cursor: "pointer" }}
                  // onClick={handleAppStoreClick(settings, "/login?signup=true")}
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.harakaride.app"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={playstore}
                  alt="Get it on Google Play"
                  style={{ cursor: "pointer" }}
                  // onClick={handleAppStoreClick(settings, "/login?signup=true")}
                />
              </a>
            </div>
          </div>
          <div className={classes.footerContainerTwo}>
            <div className={classes.footerSecondSection}>
              <div className={classes.quickLinksContainer}>
                <div className={classes.quickLinksSubContainer}>
                  <p className={classes.quickLinks}> {t(`quickLinks`)}</p>
                </div>
                <div className={classes.quickLinksSubContainer}>
                  <Link
                    style={{ textDecoration: "none", color: "inherit" }}
                    to="/"
                  >
                    <p className={classes.quickLinksOne}> {t(`headerHome`)}</p>
                  </Link>
                </div>
                <div className={classes.quickLinksSubContainer}>
                  <Link
                    style={{ textDecoration: "none", color: "inherit" }}
                    to="/term-condition"
                  >
                    <p className={classes.quickLinksOne}>
                      {" "}
                      {t(`termsAndConditions`)}
                    </p>
                  </Link>
                </div>
                <div className={classes.quickLinksSubContainer}>
                  <Link
                    style={{ textDecoration: "none", color: "inherit" }}
                    to="/privacy-policy"
                  >
                    <p className={classes.quickLinksOne}>
                      {" "}
                      {t(`privacyPolicy`)}
                    </p>
                  </Link>
                </div>
              </div>
              <div className={classes.quickLinksContainerTwo}>
                <div className={classes.quickLinksSubContainer}>
                  <p className={classes.quickLinks}> {t(`contactus`)}</p>
                </div>
                <div className={classes.quickLinksSubContainerTwo}>
                  <div className={classes.roomOutlineContainer}>
                    <RoomOutlined />
                  </div>
                  <div>
                    <p className={classes.quickLinksTwo}>
                      {" "}
                      {t(`55 Sunset Ln`)}
                    </p>
                    <p className={classes.quickLinksThree}>
                      {" "}
                      {t(`Barnstable, Massachusetts(MA), 02630`)}
                    </p>
                  </div>
                </div>
                <div className={classes.quickLinksSubContainer}>
                  <Phone />
                  <a
                    href="tel:+1234567890"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <p className={classes.quickLinksOne}>
                      {t(`(508) 362-8621`)}
                    </p>
                  </a>
                </div>
                <div className={classes.quickLinksSubContainer}>
                  <Email />
                  <a
                    href="mailto:"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <p className={classes.quickLinksOne}>info@harakaride.com</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className={classes.copyRightFooter}>{t(`copyRightHaraka`)}</p>
      </div>
    </footer>
  );
}
